export default {
    title: '公司信息管理',
    pageTitle: '企业信息',
    editPageTitle: '编辑企业信息',
    basicInfo: '基本信息',
    personInCharge: '负责人信息',
    affiliatedEntity: '所属单位',
    commonDocuments: '常用资料',
    registrationInfo: '登记支援机构',
    companyName: '名称',
    legalEntity: '法人',
    legalEntityNumber: '法人编号（13位）',
    companyType: '公司类型',
    legalPersonId: '法人编号（13位）',
    registrationDate: '登记日期',
    establishmentDate: '注册资本（日元）',
    employeeCount: '公司规模',
    foreignEmployeeCount: '外籍员工规模',
    businessScope: '销售规模（日元/年）',
    website: '公司网站',
    officeAddress: '总部地址',
    companyIntroduction: '公司介绍',
    registrationSupportService: '支援业务',
    trustMethod: '委托方式',
    remarks: '备注',
    contactName: '姓名',
    contactPosition: '职位',
    contactPhone: '电话号码／手机号码',
    contactEmail: '邮箱地址',
    mainIndustry: '主要行业',

    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    datePlaceholder: 'YYYY-MM-DD',

    paidIntroductionLicenseNumber: '收费职业介绍业务许可证号',
    paidIntroductionLicense: '收费职业介绍业务许可证',

    logo: {
        uploadText: '公司 Logo',
        fileFormat: '限 jpg/jpeg/png/webp 格式，文件需小于 10 MB',
        uploadSuccess: 'Logo 上传成功',
        uploadFailed: 'Logo 上传失败',
        changeButton: '更换',
        invalidFile: '文件无效',
    },
    license: {
        uploadText: '许可证',
        fileFormat: '限 jpg/jpeg/png/pdf/webp 格式，文件需小于 10 MB',
        uploadSuccess: '许可证上传成功',
        uploadFailed: '许可证上传失败',
        invalidFile: '文件无效',
    },
    optionsLoadFailed: '选项加载失败',
    validation: {
        companyNameRequired: '请输入名称',
        mainIndustryRequired: '请选择主要行业',
        legalEntityRequired: '请输入法人',
        employeeCountRequired: '请选择公司规模',
        foreignEmployeeCountRequired: '请选择外籍员工规模',
        contactNameRequired: '请输入姓名',
        contactPhoneRequired: '请输入电话号码／手机号码',
        legalPersonIdRequired: '请输入法人编号',
        corporateNumberLength: '法人编号必须为13位数字',
        corporateNumberMust13Digits: '法人编号必须是13位',
        insuranceNumberRequired: '请输入雇用保险适用企业编号',
        insuranceOfficeNumberRequired: '请输入雇用保险适用事业所编号',
        contactEmailRequired: '请输入邮箱地址',
        employmentOfficeNumberLength: '雇用保险适用事业所编号必须为11位数字',
        companyCategoryRequired: '请选择公司类别',
        companyTypeRequired: '请选择公司类型',
        paidIntroductionLicenseNumberRequired: '请输入收费职业介绍业务许可证号',
        companyNameExists: '该公司名称已存在',
        companyNameCheckFailed: '公司名称检查失败',
    },
};
